<template lang="pug">
  .content
    .page-heading
      .page-title.page-title_top
        | Условия работы {{renter.short_commercial_name_cases[1]}}
    agv-rules(:renter="renter" :branch="branch" :get-loss-prices-url="getLossPricesUrl" :payment-methods="aggregatorAllowedPaymentMethodsFor(renter, town.supports_cash_and_sberbank)")
</template>

<script>
import store from 'Aggregator/store/index'
import AgvRules from "Aggregator/components/agv-rules"
import aggregatorAllowedPaymentMethodsFor from "Aggregator/lib/aggregatorAllowedPaymentMethodsFor";

export default {
  name: "page-agv-rules",
  components: {AgvRules},
  props: {
    renter_id: String,
    town_id: String
  },
  methods: {
    aggregatorAllowedPaymentMethodsFor,
    getLossPricesUrl(renterId) {
      return `/api/renters/${renterId}/loss_prices.pdf`
    }
  },
  computed: {
    currentRenterState() {
      return _.get(this.$store.state.stateByRenterId, this.renter_id)
    },
    renter() {
      return this.$store.state.rentersById[this.renter_id]
    },
    town() {
      return this.$store.state.town.townsById[this.town_id]
    },
    branch() {
      return _.find(this.currentRenterState.branches, b => b.town_id === parseInt(this.town_id))
    }
  },
  beforeRouteEnter(to, fr, next) {
    store.dispatch('loadRenterState', {
      renterId: parseInt(to.params.renter_id),
      townId: parseInt(to.params.town_id)
    }).then((result) => {
      next()
    })
  },
}
</script>

<style scoped>

</style>
